<script lang="ts">
    import ClusterGroup from "$/components/pageSelect/components/ClusterGroup.svelte";
    import type { Cluster, CurrentSelection, Topic } from "../types";

    export let filteredClustersWithTopics: Cluster[];
    export let isMultipleTenants: boolean;
    export let effectivePricingPlan: number;
    export let topicRefs: Record<string, HTMLElement>;
    export let canAddTopicsToCluster: (cluster: Cluster) => boolean;
    export let addNewClusterPage: (cluster: Cluster) => Promise<void>;
    export let archiveTopic: (topic: Topic, archive: boolean) => Promise<void>;
    export let optionSelected: (option: Topic) => Promise<void>;
    export let optionEditClicked: (option: Topic) => Promise<void>;
    export let optionArchiveClicked: (option: Topic) => Promise<void>;
    export let optionLeaveClicked: (option: Topic) => Promise<void>;
    export let optionDeleteClicked: (option: Topic) => Promise<void>;
</script>

{#if filteredClustersWithTopics}
    {#each filteredClustersWithTopics as cluster, clusterIndex}
        <ClusterGroup
            {cluster}
            {clusterIndex}
            {effectivePricingPlan}
            {isMultipleTenants}
            {topicRefs}
            {addNewClusterPage}
            {archiveTopic}
            {canAddTopicsToCluster}
            {optionArchiveClicked}
            {optionDeleteClicked}
            {optionEditClicked}
            {optionLeaveClicked}
            {optionSelected}
            on:clearSearchTopicsInput
        />
    {/each}
{/if}
